import { documentToReactComponents, Options } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';

import { getBaseRichTextOptions } from './getBaseRichTextOptions';

interface IProps {
  document: Document;
  className?: string;
  options?: Options;
}

// Lean renderer for Contentful rich-text fields. No wrapper styling applied
// by default — callers wrap with their own className when they want
// typography (e.g. `prose prose-fishbrain`). Pass `options` to override the
// default renderers from `getBaseRichTextOptions`.
export const RichText = ({ document, className, options = getBaseRichTextOptions() }: IProps) => {
  const rendered = documentToReactComponents(document, options);
  return className ? <div className={className}>{rendered}</div> : <>{rendered}</>;
};
